const ipApi = {
  expirationTimeLS: 'expireZip',
  _setExpirationTimeLs: function (ttl) {
     localStorage.setItem(this.expirationTimeLS, ttl);
  },
  _getExpirationTimeLs: function () {
     return localStorage.getItem(this.expirationTimeLS);
  },
  _deleteExpirationTimeLs: function () {
     return localStorage.removeItem(this.expirationTimeLS);
  },
  _handleExpirationTime: function () {
     if (typeof zipTTL === 'undefined') return;
     const ttl = parseInt(zipTTL);
     if (ttl > 0) {
        const now = new Date();
        let expirationDate = new Date(now);
        expirationDate.setDate(now.getDate() + ttl);
        this._setExpirationTimeLs(expirationDate.toISOString());
     }
  },
  _checkExpirationTime: function () {
     let expirationDate = this._getExpirationTimeLs();
     if (expirationDate === null){
      this._handleExpirationTime();
      expirationDate = this._getExpirationTimeLs();
     }
     const now = new Date();
     const expiry = new Date(expirationDate);
     const res = (now > expiry);
     return res;
  },
  _restartLsValues: function () {
     this._deleteExpirationTimeLs();
  },
};

async function getZipByIpExpired(withoutSave = false) {
  let res = {
     zip: localStorage.getItem("detectedZipcode"),
     country_code: localStorage.getItem("detectedCountryCode")
  }
  if (ipApi._checkExpirationTime() || res.zip === null) {
     let {
        zip,
        country_code,
     } = await $.getJSON(`https://api.ipapi.com/api/check?access_key=${ipapiKey}`);
     if (withoutSave == false) {
        localStorage.setItem("detectedZipcode", zip);
        localStorage.setItem("detectedCountryCode", country_code);
     }
     res.zip = zip;
     res.country_code = country_code;
  }

  return res;
}
$(document).on("ready", function () {
  if (ipApi._checkExpirationTime()) {
     getZipByIpExpired(false).then(function (res) {
        ipApi._handleExpirationTime();
     });
  };
});